export default "__VITE_ASSET__0890ebc3__"